export const convertToDollars = (priceInCents: number) => parseFloat((priceInCents * 0.01).toFixed(2))
export const convertToCents = (priceInCents: number) => Math.round(priceInCents * 100)

export const priceFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})
